<template>
  <div>
    <multiselect
      v-model="selectedGroup"
      class="mb-3"
      :options="groups"
      :custom-label="customLabel"
      placeholder="近隣グループ名で検索"
      label="name"
      track-by="name"
      :loading="isSearching"
      @search-change="searchGroups"
    >
      <span slot="noResult">近隣グループが見つかりません</span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "SearchGroups",
  components: { Multiselect },
  props: {
    selected: {
      type: Object,
      default: null,
    },
    apiFields: {
      type: Array,
      default: () => ["id", "name"],
    },
    filter: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      selectedGroup: this.selected,
      isSearching: false,
      toggleDropdown: false,
      groups: [],
      sorterValue: { column: "updated_at", asc: false },
    };
  },
  computed: {
    sort() {
      return this.sorterValue.asc ? this.sorterValue.column : `-${this.sorterValue.column}`;
    },
  },
  watch: {
    selectedGroup() {
      this.$emit("update:selected", Object.assign({}, this.selectedGroup));
    },
  },
  async created() {
    await this.searchGroups();
  },
  methods: {
    customLabel({ id, name }) {
      return `[${id}] ${name}`;
    },
    async searchGroups(query) {
      if (this.isSearching) return;

      this.isSearching = true;
      const req_params = {
        query: query,
        fields: this.apiFields.concat(["id"]).join(","),
        sort: this.sort,
      };
      const response = await this.$axios.get(`/api/v2/core/admin/groups`, { params: req_params }).catch(() => (this.isSearching = false));
      this.groups = response.data.filter(this.filter);
      this.isSearching = false;
    },
  },
};
</script>
